import axios from 'axios';

export const state = {
  openFpvReports: [],
  approvedFpvReports: [],
  openLoading: false,
  approvedLoading: false,
};

export const mutations = {
  setOpenFpvReports(context, openFpvReports) {
    context.openFpvReports = openFpvReports;
    context.openLoading = false;
  },
  setOpenLoading(context, value) {
    context.openLoading = value;
  },
  setApprovedFpvReports(context, approvedFpvReports) {
    context.approvedFpvReports = approvedFpvReports;
    context.approvedLoading = false;
  },
  setApprovedLoading(context, value) {
    context.approvedLoading = value;
  },
};

export const actions = {
  async getOpenFpvReports({ commit, rootState }, query) {
    try {
      commit('setOpenLoading', true);
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      const fpvReports = await axios.get(
        `${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/documents/admin/list/fpv-report/open?${query}`,
        options,
      ).then(response => response);

      commit('setOpenFpvReports', fpvReports.data);
      commit('setOpenLoading', false);
    } catch (err) {
      commit('setOpenLoading', false);
    }
  },
  async getApprovedFpvReports({ commit, rootState }, query) {
    try {
      commit('setApprovedLoading', true);
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      const fpvReports = await axios.get(
        `${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/documents/admin/list/fpv-report/approved?${query}`,
        options,
      ).then(response => response);

      commit('setApprovedFpvReports', fpvReports.data);
      commit('setApprovedLoading', false);
    } catch (err) {
      commit('setApprovedLoading', false);
    }
  },
  async fpvReportActionCall({ commit }, data) {
    try {
      commit('setApprovedLoading', true);
      commit('setOpenLoading', true);
      await axios.post(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/documents/admin/fpv-report`, data)
        .then(response => response);
    } catch (err) {
      commit('setApprovedLoading', false);
      commit('setOpenLoading', false);
    }
  },
  async triggerFpvReports({ commit }, data) {
    try {
      commit('setApprovedLoading', true);
      commit('setOpenLoading', true);
      const result = await axios.post(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/fpv-report/create-all`, data)
        .then(response => response);
      commit('setApprovedLoading', false);
      commit('setOpenLoading', false);

      return result;
    } catch (err) {
      commit('setApprovedLoading', false);
      commit('setOpenLoading', false);

      return err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  ireDocumentsPushLatestState({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/maintenance/sendPdfCreatedEvents`, payload)
      .then(data => data).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const fpvReportsStore = {
  state,
  mutations,
  actions,
};

export default fpvReportsStore;



// WEBPACK FOOTER //
// ./src/store/ire/fpvReportsStore.js